<app-basic-select [options]="actions" [(ngModel)]="localValue" [iconClass]="'toggles fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
